module.exports = __webpack_public_path__ + "img/app_img4_1.36b72c3e.png";